import { useState } from 'react';
import axios from 'axios';
import { Alert, Box, Button, Paper, Stack, TextField, Typography } from '@mui/material';

export default function BulkPrinterIPAssignment() {
    const [printerIP, setPrinterIP] = useState('');
    const [printerPort, setPrinterPort] = useState('9100');
    const [saving, setSaving] = useState(false);
    const [result, setResult] = useState(null);

    const assignIP = async () => {
        const ip = printerIP.trim();
        if (!ip) return setResult({ severity: 'error', message: 'Printer IP enter karein.' });
        if (!window.confirm(`Testing ke liye tamam configured printers ko ${ip}:${printerPort || 9100} par assign karna hai?`)) return;
        setSaving(true);
        setResult(null);
        try {
            const response = await axios.put(`${global.SET_API_URL}printerBulkAssignment/assign-single-ip`, { printerIP: ip, printerPort: Number(printerPort || 9100) });
            const updated = response.data.updated || {};
            setResult({ severity: 'success', message: `${response.data.message} Kitchens: ${updated.kitchens || 0}, Takeaway: ${updated.takeawayCounters || 0}, Dispatch: ${updated.dispatchCounters || 0}, Cash/Bill & Delivery Note: ${updated.cashCounters || 0}.` });
        } catch (error) {
            setResult({ severity: 'error', message: error.response?.data?.message || 'Printer assignment update nahi ho saka.' });
        } finally {
            setSaving(false);
        }
    };

    return <Box sx={{ p: 3, maxWidth: 760 }}><Paper elevation={2} sx={{ p: 3 }}><Stack spacing={2}>
        <Box><Typography variant="h5" fontWeight={700}>Single Printer IP Assignment</Typography><Typography variant="body2" color="text.secondary" sx={{ mt: 0.75 }}>Testing mode: ek hi printer IP kitchens, takeaway counters, dispatch counters aur cash counters par apply hoga. Cash counter se final bill aur delivery note bhi print hotay hain.</Typography></Box>
        {result && <Alert severity={result.severity}>{result.message}</Alert>}
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}><TextField fullWidth required label="Printer IP" placeholder="192.168.1.100" value={printerIP} onChange={(event) => setPrinterIP(event.target.value)} /><TextField sx={{ minWidth: { sm: 150 } }} label="Port" type="number" value={printerPort} onChange={(event) => setPrinterPort(event.target.value)} inputProps={{ min: 1, max: 65535 }} /></Stack>
        <Alert severity="warning">Yeh action current IP aur port overwrite karega. Production printers restore karne ke liye unki individual settings dobara save karni hongi.</Alert>
        <Button variant="contained" onClick={assignIP} disabled={saving}>{saving ? 'Assigning...' : 'Assign Same IP to All Printers'}</Button>
    </Stack></Paper></Box>;
}
